$( document ).ready(function() {
  
  // Handler for .ready() called.
  $('.header__menu-item.list-menu__item.link.focus-inset').mouseover(function(){
    var opened_menu = $(this).parent();
    opened_menu_id = opened_menu.attr('id');
    console.log(opened_menu_id);
    if(opened_menu_id){
      $(opened_menu_id).attr('open', true);
    }
  });
  
  $('.header__menu-item.list-menu__item.link.focus-inset').click(function(){
    var opened_menu = $(this).parent();
    opened_menu_link = opened_menu.attr('link');
    window.location.replace(opened_menu_link);
  });

});